import { render, staticRenderFns } from "./StaffSidebar.vue?vue&type=template&id=bb699cbe&scoped=true&"
import script from "./StaffSidebar.vue?vue&type=script&lang=js&"
export * from "./StaffSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb699cbe",
  null
  
)

export default component.exports